module.exports = __webpack_public_path__ + "static/img/csss_chi_2.dd4932a9.jpg";